import React from "react";
import { createPortal } from "react-dom";
import { AMOUNT_PICKER_OPTIONS } from "../constants/upDownConstants";
import { parseStake, roundToCents } from "../utils/upDownFormatters";

export function AmountPickerDropdown({
  isOpen,
  position,
  activeLayout,
  wallet,
  amount,
  panelRef,
  onSelectOption,
  onClose,
}) {
  if (!isOpen || !position || typeof document === "undefined") {
    return null;
  }

  const amountOptions =
    wallet?.binary?.amount_settings?.map((amt) => amt?.amount?.toFixed(2)) ||
    AMOUNT_PICKER_OPTIONS;

  return createPortal(
    <>
      {position.isMobileSheet && (
        <button
          type="button"
          aria-label="Close amount picker"
          className="fixed inset-0 z-[9995] bg-black/55"
          onClick={onClose}
        />
      )}
      <div
        ref={panelRef}
        role="dialog"
        aria-label="Quick amount"
        className={`z-[9996] overflow-hidden rounded-xl border border-white/10 bg-[#111] p-2 text-white shadow-2xl shadow-black/50 transition-all duration-150 ease-out ${
          position.isMobileSheet
            ? "fixed inset-x-3 bottom-3 animate-[timePickerSheetIn_160ms_ease-out] pb-[calc(0.5rem+env(safe-area-inset-bottom))]"
            : "fixed origin-bottom animate-[timePickerMenuIn_120ms_ease-out]"
        }`}
        style={
          position.isMobileSheet
            ? undefined
            : {
                top: `${position.top}px`,
                left: `${position.left}px`,
                maxWidth:
                  activeLayout && activeLayout !== "single"
                    ? "190px"
                    : "250px",
                width: "100%",
              }
        }
      >
        <div
          role="listbox"
          className="max-h-[200px] overflow-y-auto scroll-smooth rounded-lg bg-[#1a1a1a] p-1 [scroll-snap-type:y_mandatory]"
        >
          {amountOptions.map((value) => {
            const isSelected =
              roundToCents(parseStake(value)) === roundToCents(amount);
            return (
              <button
                key={value}
                type="button"
                role="option"
                aria-selected={isSelected}
                className={`mb-1 flex h-10 w-full items-center justify-center rounded-xl border text-sm font-bold transition last:mb-0 ${
                  isSelected
                    ? "border-[#ffd43b] bg-[#ffd43b] text-black shadow-lg shadow-[#ffd43b]/10"
                    : "border-white/5 bg-transparent text-white/80 hover:border-white/15 hover:bg-white/10 active:bg-white/15"
                }`}
                onClick={() => onSelectOption(value)}
              >
                ${value}
              </button>
            );
          })}
        </div>
      </div>
    </>,
    document.body,
  );
}

